<template>
  <button
    type="button"
    class="add-pill relative inline-flex items-center justify-center align-middle p-3 -m-3 md:p-0 md:m-0"
    :class="{ 'cursor-not-allowed': started && !added }"
    :aria-pressed="String(added)"
    :aria-label="ariaLabel"
    :aria-disabled="started && !added ? 'true' : null"
    :title="started ? 'Match has started' : ariaLabel"
    v-on:click.stop.prevent="toggle"
  >
    <!-- said straight away on the tap, not after a round trip to price the slip -->
    <span
      v-if="flash"
      class="absolute bottom-full right-0 mb-1 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-[10px] font-semibold normal-case text-white shadow z-30"
      role="status"
      >Match started</span
    >
    <span
      class="pill-ring w-5 h-5 rounded-full border text-[13px] leading-none flex items-center justify-center transition-colors"
      :class="ringClass"
      aria-hidden="true"
      >{{ added ? "✓" : "+" }}</span
    >
  </button>
</template>

<script>
import { trackFeature } from "../../analytics";

export default {
  name: "AddPill",
  props: {
    // {id, label, match, match_id, kickoff, side}
    selection: { type: Object, required: true },
  },
  data() {
    // the clock as of the last render or tap; a page left open across kick-off would otherwise
    // keep offering the bet until the slip came back priced as "started"
    return { now: Date.now(), flash: false };
  },
  computed: {
    added() {
      return this.$store.getters["betslip/has"](this.selection.id);
    },
    started() {
      return (
        !!this.selection.kickoff &&
        this.selection.kickoff * 1000 < this.now
      );
    },
    ariaLabel() {
      const match = this.selection.match ? ` (${this.selection.match})` : "";
      if (this.added) return `Remove ${this.selection.label}${match} from slip`;
      return `Add ${this.selection.label}${match} to slip`;
    },
    ringClass() {
      if (this.added) return "added bg-[#22c55e] border-[#22c55e] text-white";
      if (this.started) return "opacity-40 border-gray-300 text-gray-500";
      return "idle border-gray-300 text-gray-500 bg-white/60";
    },
  },
  beforeDestroy() {
    clearTimeout(this.flashTimer);
  },
  methods: {
    toggle() {
      if (!this.$store.getters.subscriptionType) {
        trackFeature("betslip_upgrade_click", "betslip", { from: "pill" });
        this.$router.push("/signup/");
        return;
      }
      this.now = Date.now();
      if (this.started && !this.added) {
        trackFeature("betslip_started_tap", "betslip");
        this.flash = true;
        clearTimeout(this.flashTimer);
        this.flashTimer = setTimeout(() => (this.flash = false), 2500);
        return;
      }
      this.$store.dispatch("betslip/toggle", this.selection);
    },
  },
};
</script>

<style scoped>
.add-pill:hover .pill-ring.idle,
.add-pill:focus-visible .pill-ring.idle {
  border-color: #1d4ed8;
  color: #1d4ed8;
}
.add-pill:focus-visible {
  outline: none;
}
.add-pill:focus-visible .pill-ring {
  box-shadow: 0 0 0 2px #1d4ed8;
}
</style>
